import { useState } from 'react'
import { Check, Upload } from 'lucide-react'

export default function UploadBox({ label }) {
  const [nome, setNome] = useState(null)
  return (
    <label className={`flex cursor-pointer items-center justify-between rounded-xl border-2 border-dashed px-4 py-4 transition ${nome ? 'border-brand-600 bg-brand-50' : 'border-slate-300 bg-white hover:border-slate-400'}`}>
      <div className="flex items-center gap-3">
        <span className={`rounded-lg p-2 ${nome ? 'bg-brand-600 text-white' : 'bg-slate-100 text-slate-500'}`}>
          {nome ? <Check size={18} /> : <Upload size={18} />}
        </span>
        <div>
          <div className="text-sm font-semibold text-slate-800">{label}</div>
          <div className="text-xs text-slate-400">{nome || 'PDF ou foto — toque para enviar'}</div>
        </div>
      </div>
      <input type="file" className="sr-only" onChange={(e) => setNome(e.target.files?.[0]?.name || 'arquivo enviado')} />
    </label>
  )
}
